import {
  hexToRgb,
  rgbToCmyk,
  simulatePrint,
  rgbToHex,
  formatRgb,
  formatCmyk,
  textOn,
} from "../lib/color";
import { CopyButton } from "./CopyButton";

export function PaletteSwatch({ hex, label, testId, onSelect, copyTestId, showSim = true }) {
  const rgb = hexToRgb(hex);
  const cmyk = rgbToCmyk(rgb);
  const txt = textOn(rgb);
  const printRgb = simulatePrint(rgb);
  const printHex = rgbToHex(printRgb);

  return (
    <button
      data-testid={testId}
      onClick={onSelect}
      className="group relative text-left border border-border flex flex-col overflow-hidden hover:border-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-foreground"
    >
      <div className="relative h-28 md:h-32 flex" style={{ backgroundColor: hex }}>
        {showSim && (
          <div
            className="w-1/3 border-l border-black/10"
            style={{ backgroundColor: printHex }}
            title={`Print simulated: ${printHex}`}
          />
        )}
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <CopyButton value={hex} testId={copyTestId} textColor={txt} />
        </div>
        {label && (
          <span
            className="absolute top-2 left-2 text-[10px] font-medium uppercase tracking-[0.2em]"
            style={{ color: txt }}
          >
            {label}
          </span>
        )}
      </div>
      <div className="p-3 space-y-1 bg-surface">
        <div className="flex justify-between items-baseline">
          <span className="text-[10px] uppercase tracking-[0.2em] text-muted">HEX</span>
          <span className="font-mono text-xs">{hex.toUpperCase()}</span>
        </div>
        <div className="flex justify-between items-baseline">
          <span className="text-[10px] uppercase tracking-[0.2em] text-muted">RGB</span>
          <span className="font-mono text-xs">{formatRgb(rgb)}</span>
        </div>
        <div className="flex justify-between items-baseline">
          <span className="text-[10px] uppercase tracking-[0.2em] text-muted">CMYK</span>
          <span className="font-mono text-xs">{formatCmyk(cmyk)}</span>
        </div>
      </div>
    </button>
  );
}
